import React, { Component, PureComponent } from 'react';

import { database, MyRef, myStorage, firestore } from '../../Common/Firebase';
import { subjectsObj, subjectsUA } from '../../Common/Database';

import 'react-quill/dist/quill.snow.css';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { MenuItem, FormControl, Select, InputLabel } from '@mui/material';
import { format, parse } from 'date-fns';
import { ref, set } from 'firebase/database';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import ImageResize from 'quill-image-resize-module-react';
import { v4 as uuidv4 } from 'uuid';

import withNavigateHook from '../../Components/withNavigateHook';
import PopupImage from './PopupImage';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import { convertImageToWebp } from '../../Common/MediaConverter';

import './style.scss';
import toast from 'react-hot-toast';
import { withTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import { Button, Input } from 'reactstrap';

import { ReactComponent as DescriptionSvg } from '../../assets/img/file-word-solid.svg';
import { throwErrorRollbar } from '../../index';

const Quill = ReactQuill.Quill;
const BlockEmbed = Quill.import('blots/block/embed');
const Inline = Quill.import('blots/inline');
class DividerBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('controls', '');
    node.setAttribute('class', 'line-row-homework-c');

    // Добавьте эту строку для добавления атрибута
    node.setAttribute('data-line-index', new Date().getTime().toString());

    return node;
  }
}

class WordBlot extends BlockEmbed {
  static create(data) {
    let node = super.create();
    node.setAttribute('href', data.url);
    node.setAttribute('class', 'word-item');
    node.setAttribute('target', '_blank');
    node.setAttribute('name', data.filename || 'Unknown File'); // Сохраняем имя файла в атрибуте 'name'
    node.innerHTML = data.filename || 'Unknown File'; // Используем название файла или 'Unknown File', если название не предоставлено

    return node;
  }

  static value(node) {
    return {
      url: node.getAttribute('href'),
      filename: node.getAttribute('name') || node.innerText, // Если внутренний текст отсутствует, то возвращаем значение из атрибута 'name'
    };
  }
}
class AudioBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'audio-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class ImageBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('class', 'image-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class VideoBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'video-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class LinkBlot extends Inline {
  static create(url) {
    const node = super.create();
    node.setAttribute('href', url);
    node.setAttribute('class', 'link-item');
    node.setAttribute('target', '_blank');
    node.setAttribute('contenteditable', 'false');
    return node;
  }

  static formats(node) {
    return node.getAttribute('href');
  }

  static value(node) {
    return node.getAttribute('href');
  }
}

class ImageFormat extends Quill.import('formats/image') {
  static formats(domNode) {
    return {
      alt: domNode.getAttribute('alt'),
      src: domNode.getAttribute('src'),
      width: domNode.getAttribute('width'),
    };
  }
  format(name, value) {
    if (name === 'width') {
      this.domNode.setAttribute('width', value);
    } else {
      super.format(name, value);
    }
  }
}

class CreateHomework extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      homeWorkValue: '',
      contextObject: null,
      ignoreFirstUpdate: true,
      name: '',
      loading: false,
      content: '',
      message: '',
      deletedUrls: [],
      addedUrls: [],
      subject: '',
      subjects: [],
      isForNotebook: false,
      progressFilePost: 0,
      rowApdute: '',
      arrayFilesEditor: [],
      arrayFiles: [],
      selectedDate: new Date(),
      subItems: false,
      subArrayCheckeds: [],
      titles: [''],
      videoInputRef: React.createRef(),
      audioInputRef: React.createRef(),
      imageInputRef: React.createRef(),
      wordInputRef: React.createRef(),
      imageSrc: null,
      flagFormValidate: false,
      formPointsFlag: false,
      lineIndices: '',
      mail: '',
    };

    this.context = React.createRef();
    this.onTextEditorChange = this.onTextEditorChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.save = this.save.bind(this);
    this.onNameChange = this.onNameChange.bind(this);
    this.setContext = this.setContext.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleImage = this.handleImage.bind(this);
    this.handleVideo = this.handleVideo.bind(this);
    this.handleMusic = this.handleMusic.bind(this);
    this.removeUrlListener = this.removeUrlListener.bind(this);
    this.handleNewPart = this.handleNewPart.bind(this);
    this.onSubjectChange = this.onSubjectChange.bind(this);
    this.getCurrentDate = this.getCurrentDate.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.closeImagePopup = this.closeImagePopup.bind(this);
    this.handleLinkInsert = this.handleLinkInsert.bind(this);

    AudioBlot.blotName = 'audio';
    AudioBlot.tagName = 'audio';

    ImageBlot.blotName = 'img';
    ImageBlot.tagName = 'img';

    VideoBlot.blotName = 'video';
    VideoBlot.tagName = 'video';

    DividerBlot.blotName = 'divider';
    DividerBlot.tagName = 'hr';

    WordBlot.blotName = 'word';
    WordBlot.tagName = 'a';

    LinkBlot.blotName = 'link';
    LinkBlot.tagName = 'span';

    Quill.register(AudioBlot);
    Quill.register(DividerBlot);
    Quill.register(ImageBlot);
    Quill.register(VideoBlot);
    Quill.register(LinkBlot);
    // Quill.register('modules/imageResize', ImageResize);
    // Quill.register(ImageFormat, true);
    Quill.register('formats/word', WordBlot);
    Quill.register('modules/video', false);
  }

  getCurrentDate = (dateArg, exemp) => {
    const date = dateArg;
    switch (exemp) {
      case 1:
        const dateItem = new Date(date);
        const formattedDate = format(dateItem, 'dd.MM.yyyy');
        return formattedDate;
        break;
      case 2:
        const dateString = date;
        const dateUpdate = parse(dateString, 'dd.MM.yyyy', new Date());
        return dateUpdate;
        break;
    }
  };

  componentDidMount() {
    this.setState({
      subjects: subjectsUA,
    });

    if (sessionStorage.getItem('updateHomework')) {
      const getContentFunc = async id => {
        const docRef = doc(firestore, 'homeworks-content', id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          return JSON.parse(docSnap.data().content);
        } else {
          console.log('No such document!');
        }
      };

      let resp = getContentFunc(JSON.parse(sessionStorage.getItem('updateHomework')).id);
      let resp2 = resp.then(resp => {
        let NewArr = resp.ops
          .map(item => typeof item.insert == 'object' && Object.values(item.insert)[0])
          .filter(item => item);

        this.setState({
          content: resp,
          arrayFiles: NewArr,
        });
      });
      this.setState({
        rowApdute: JSON.parse(sessionStorage.getItem('updateHomework')),
        name: JSON.parse(sessionStorage.getItem('updateHomework')).name,
        mail: JSON.parse(sessionStorage.getItem('updateHomework')).mail,
        subject: JSON.parse(sessionStorage.getItem('updateHomework')).subject,
        titles: JSON.parse(sessionStorage.getItem('updateHomework')).titles,
        selectedDate: this.getCurrentDate(JSON.parse(sessionStorage.getItem('updateHomework')).deadline, 2),
        isForNotebook: JSON.parse(sessionStorage.getItem('updateHomework')).notebook,
      });
    }

    if (this.state.contextObject && this.state.contextObject.editor) {
      this.state.contextObject.editor.root.addEventListener('click', this.handleImageClick);
    }

    document.body.addEventListener('click', this.handleWordItemClick);
  }

  componentWillUnmount() {
    if (this.state.contextObject && this.state.contextObject.editor) {
      this.state.contextObject.editor.root.removeEventListener('click', this.handleImageClick);
    }

    document.body.removeEventListener('click', this.handleWordItemClick);
  }

  handleImageClick(e) {
    const image = e.target.closest('img');
    if (image) {
      this.setState({ imageSrc: image.src });
    }
  }

  closeImagePopup() {
    this.setState({ imageSrc: null });
  }

  componentDidUpdate(prevProps, prevState) {
    const arrOneItems = [{ [this.state.name]: false }];
    const arrMoreItems = Object.values(this.state.titles).map((item, i) => {
      return { [item]: false };
    });

    if (prevState.titles !== this.state.titles) {
      if (this.state.subArrayCheckeds.length > Object.values(this.state.titles).length) {
        this.setState({
          flagFormValidate: true,
        });
      } else {
        this.setState({
          flagFormValidate: false,
        });
      }
    }

    if (prevState.subArrayCheckeds !== this.state.subArrayCheckeds) {
      if (this.state.subArrayCheckeds.length > Object.values(this.state.titles).length) {
        this.setState({
          formPointsFlag: true,
          flagFormValidate: true,
        });
      } else {
        this.setState({
          flagFormValidate: false,
        });
      }
    }
  }

  handleWordItemClick = e => {
    if (e.target.tagName === 'A' && e.target.classList.contains('word-item')) {
      window.open(e.target.getAttribute('href'), '_blank');
      e.preventDefault();
    }
  };

  //Метод в котором разделяю htnl по разделителю
  handleHtmlContent = content => {
    const htmlArray = content.includes('<hr') ? content.split('<hr controls="" class="line-row-homework-c">') : [];
    const finalHtmlArray = [];
    const lineIndices = [];

    // Тут мы используем регулярное выражение для извлечения всех значений атрибута data-line-index
    const regex = /data-line-index="(\d+)"/g;
    let match;
    while ((match = regex.exec(content)) !== null) {
      lineIndices.push(match[1]);
    }

    if (htmlArray.length > 0) {
      htmlArray.forEach(htmlString => {
        if (htmlString.includes('<hr')) {
          const splitHtmlArray = htmlString.split('<hr');
          splitHtmlArray.forEach(splitHtmlString => {
            if (splitHtmlString.trim() !== '') {
              finalHtmlArray.push(splitHtmlString);
            }
          });
        } else {
          finalHtmlArray.push(htmlString);
        }
      });
    }

    //в зависимости от разделенных html делаем массив с чекедами
    if (htmlArray.length > 0) {
      const count = finalHtmlArray.length;
      const array = new Array(count).fill(false);
      this.setState({
        subItems: true,
        subArrayCheckeds: array,
        lineIndices: lineIndices, // сохраняем значения атрибутов в состояние
      });
    } else if (htmlArray.length === 0) {
      this.setState({
        subItems: false,
        subArrayCheckeds: false,
        lineIndices: [], // устанавливаем пустой массив, если элементов <hr> нет
      });
    }
  };

  onTextEditorChange = (value, delta, source, editor) => {
    if (this.ignoreFirstUpdate) {
      this.state.ignoreFirstUpdate = false;
      return;
    }
    const currentContentDelta = editor.getContents();
    let newArr = currentContentDelta.ops.filter(op => typeof op.insert === 'object' && Object.values(op.insert)[0]);

    const prevContentDeltaString = JSON.stringify(this.state.content);
    const currentContentDeltaString = JSON.stringify(currentContentDelta);
    const prevArrayFilesEditorString = JSON.stringify(this.state.arrayFilesEditor);
    const newArrayFilesEditorString = JSON.stringify(newArr);

    if (prevContentDeltaString !== currentContentDeltaString) {
      this.handleHtmlContent(value);

      this.setState({
        content: currentContentDelta,
        arrayFilesEditor: newArr,
      });
    }
  };

  handleInputChange = (index, event) => {
    let newTitles = { ...this.state.titles };
    newTitles[index] = event.target.value;
    this.setState({ titles: newTitles });
  };

  onKeyDown = async event => {
    if (event.keyCode === 8) {
      if (this.state.arrayFiles.length > this.state.arrayFilesEditor.length) {
        for (let item of this.state.arrayFiles) {
          //TODO: НЕ ТРОГАТЬ, НЕ УДАЛЯТЬ, ВРЕМЕННАЯ МЕРА_ НУЖНО БУДИТ РЕШИТЬ ПРОБЛЕМУ С ОТОБРАЖЕНИЕМ У УЧЕНИКОВ
          // if (this.state.arrayFilesEditor.includes(item) == false) {
          //   const storageRef = MyRef(myStorage, item);
          //   const stringDelete = storageRef._location.path_;
          //   const desertRef = MyRef(myStorage, stringDelete);
          //   this.setState({
          //     arrayFiles: this.state.arrayFiles.filter(
          //       (filterElem) => filterElem !== item,
          //     ),
          //   });
          //   try {
          //     await deleteObject(desertRef)
          //       .then(() => {
          //         console.log('deleted');
          //       })
          //       .catch((error) => {
          //         console.log(error);
          //       });
          //   } catch (error) {
          //     console.log(error);
          //   }
          // }
        }
      }
    }
  };

  onNameChange(event) {
    this.setState({ name: event.target.value });
  }

  save() {
    if (this.state.rowApdute) {
      const now = new Date();
      const dateTimeParsing2 = format(now.setHours(now.getHours()), 'dd.MM.yyyy');

      const arrOneItems = [{ [this.state.name]: false }];
      const arrMoreItems = Object.values(this.state.titles).map((item, i) => {
        return { [item]: false };
      });

      const resp = new Promise(async (resolve, reject) => {
        await setDoc(doc(firestore, 'homeworks-content/', this.state.rowApdute.id), {
          content: JSON.stringify(this.state.content),
          subject: subjectsObj[this.state.subject],
          id: this.state.rowApdute.id,
        });

        await set(ref(database, 'Homeworks/' + this.state.rowApdute.id), {
          id: this.state.rowApdute.id,
          name: this.state.name,
          subject: subjectsObj[this.state.subject],
          content: 'homeworks-content/' + this.state.rowApdute.id,
          time: dateTimeParsing2,
          notebook: this.state.isForNotebook,
          completed: false,
          mail: this.state.mail,
          deadline: this.getCurrentDate(this.state.selectedDate, 1),
          subItems: this.state.subItems,
          subArrayCheckeds: this.state.subArrayCheckeds,
          titles: this.state.titles,
          teacherCheckeds: JSON.stringify(Object.values(this.state.titles).length > 1 ? arrMoreItems : arrOneItems),
        });
        return resolve(
          toast.success(this.props.t('popupHomeworkUpdated')),
          sessionStorage.removeItem('updateHomework'),
          this.props.navigation('/homework'),
        );
      });
      resp.then(resolve => console.log(resolve));
      resp.catch(reject => console.log(reject));
    }

    if (!this.state.rowApdute) {
      const id = uuidv4();
      const now = new Date();
      const dateTimeParsing2 = format(now.setHours(now.getHours()), 'dd.MM.yyyy');

      const arrOneItems = [{ [this.state.name]: false }];
      const arrMoreItems = Object.values(this.state.titles).map((item, i) => {
        return { [item]: false };
      });

      const resp = new Promise(async (resolve, reject) => {
        await setDoc(doc(firestore, 'homeworks-content/', id), {
          content: JSON.stringify(this.state.content),
          subject: subjectsObj[this.state.subject],
          id: id,
        });

        await set(ref(database, 'Homeworks/' + id), {
          id: id,
          name: this.state.name,
          subject: subjectsObj[this.state.subject],
          content: 'homeworks-content/' + id,
          time: dateTimeParsing2,
          notebook: this.state.isForNotebook,
          completed: false,
          mail: this.props.mail,
          deadline: this.getCurrentDate(this.state.selectedDate, 1),
          subItems: this.state.subItems,
          subArrayCheckeds: this.state.subArrayCheckeds,
          titles: this.state.titles,
          teacherCheckeds: JSON.stringify(Object.values(this.state.titles).length > 1 ? arrMoreItems : arrOneItems),
        });
        return resolve(
          toast.success(this.props.t('popupHomeworkAdded')),
          sessionStorage.removeItem('updateHomework'),
          this.props.navigation('/homework'),
        );
      });
      resp.then(resolve => console.log(resolve));
      resp.catch(reject => console.log(reject));
    }
  }

  removeUrlListener(delta, oldContents, source) {
    let currentContenst = this.state.contextObject.getEditor().getContents();

    let deletedDiffs = currentContenst.diff(oldContents);
    let deletedUrls = this.getUrls(deletedDiffs);

    deletedUrls.forEach(url => {
      this.state.deletedUrls.push(url);
      this.state.addedUrls.pop(url);
    });

    let addedUrls = this.getUrls(delta);

    addedUrls.forEach(url => {
      this.state.addedUrls.push(url);
    });
  }

  getUrls(diffs) {
    return diffs.ops
      .filter(diff => diff.insert && (diff.insert.image || diff.insert.video || diff.insert.audio))
      .map(diff => {
        if (diff.insert.image) return diff.insert.image;

        if (diff.insert.video) return diff.insert.video;

        return diff.insert.audio;
      });
  }

  setContext(context) {
    this.setState({ contextObject: context }, () => {
      if (this.state.contextObject && this.state.contextObject.editor) {
        this.state.contextObject.editor.root.addEventListener('click', this.handleImageClick);
      }
    });
  }

  handleWordInsert = e => {
    const wordInput = e.target;
    if (wordInput && wordInput.files.length > 0) {
      const file = wordInput.files[0];

      const storageRef = MyRef(myStorage, 'Домашние-задания/word/' + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          // Отслеживайте процесс загрузки, если необходимо
        },
        error => {
          // Обработайте ошибки загрузки, если необходимо
        },
        () => {
          // Получите URL загруженного файла и вставьте его в контент Quill
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            const quill = this.state.contextObject.getEditor();
            const range = quill.getSelection(true);
            quill.insertEmbed(
              range.index,
              'word',
              {
                url: downloadURL, // Предположительно, вы должны будете обработать этот файл, чтобы получить URL
                filename: file.name, // Название файла
              },
              Quill.sources.USER,
            );

            // Добавьте URL файла в массив файлов, если необходимо
            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });

            wordInput.value = ''; // Очистите поле ввода после вставки файла
          });
        },
      );
    }
  };

  handleVideoInsert = () => {
    const videoInput = this.state.videoInputRef.current;
    if (videoInput && videoInput.files.length > 0) {
      const file = videoInput.files[0];
      const formData = new FormData();
      formData.append('file', file);

      const quill = this.state.contextObject.getEditor();
      const range = quill.getSelection(true);

      const storageRef = MyRef(myStorage, 'Домашние-задания/video/' + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });

            quill.insertEmbed(range.index, 'video', downloadURL, Quill.sources.USER);

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });

            videoInput.value = '';
          });
        },
      );
    }
  };

  handleImageInsert = async () => {
    const imageInput = this.state.imageInputRef.current;
    if (imageInput && imageInput.files.length > 0) {
      const file = imageInput.files[0];
      const formData = new FormData();

      const webpFile = await convertImageToWebp(URL.createObjectURL(file), file);
      formData.append('file', webpFile);

      const quill = this.state.contextObject.getEditor();
      const range = quill.getSelection(true);

      const storageRef = MyRef(myStorage, 'Домашние-задания/image/' + webpFile.name);

      const uploadTask = uploadBytesResumable(storageRef, webpFile);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });

            quill.insertEmbed(range.index, 'image', downloadURL, Quill.sources.USER);

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });

            imageInput.value = '';
          });
        },
      );
    }
  };

  handleAudioInsert = () => {
    const audioInput = this.state.audioInputRef.current;
    if (audioInput && audioInput.files.length > 0) {
      const file = audioInput.files[0];
      const formData = new FormData();
      formData.append('file', file);

      const quill = this.state.contextObject.getEditor();
      const range = quill.getSelection(true);

      const storageRef = MyRef(myStorage, 'Домашние-задания/audio/' + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });

            quill.insertEmbed(range.index, 'audio', downloadURL, Quill.sources.USER);

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });

            audioInput.value = '';
          });
        },
      );
    }
  };

  handleLinkInsert = url => {
    if (url) {
      let quill = this.state.contextObject.getEditor();
      let selection = quill.getSelection(true);

      if (selection) {
        const { index } = selection;

        if (text) {
          const linkAttributes = url;
          const spanNode = document.createElement('span');
          spanNode.innerText = text;
          spanNode.setAttribute('href', linkAttributes);
          spanNode.setAttribute('class', 'link-item');
          spanNode.setAttribute('target', '_blank');
          spanNode.setAttribute('contenteditable', 'false');
          spanNode.addEventListener('click', () => {
            window.open(linkAttributes, '_blank');
          });

          quill.insertEmbed(index, 'link', linkAttributes, Quill.sources.USER);
          quill.insertText(index + 1, '\uFEFF');
          quill.setSelection(index + 1, Quill.sources.SILENT);
          quill.clipboard.dangerouslyPasteHTML(index + 1, spanNode.outerHTML);
          quill.setSelection(index + 1 + spanNode.innerText.length, Quill.sources.SILENT);
        }
      }
    }
  };

  CustomToolbar = () => (
    <>
      <div className="homework-edit-toolbar" id="toolbar">
        <div className="toolbar-wrap">
          <button className="ql-bold" />
          <button className="ql-italic" />
          <select className="ql-color">
            <option value="red" />
            <option value="green" />
            <option value="blue" />
            <option value="orange" />
            <option value="violet" />
            <option value="#d0d1d2" />
            <option value="black" />
          </select>
          <button
            className="ql-link"
            onClick={url => {
              this.handleLinkInsert(url);
            }}
          ></button>
          <button className="ql-insertLine ">{this.props.t('Split D/Z')}</button>
          <div className="ql-image button-icon toolbar-add-img">
            <input
              id="imageInput"
              type="file"
              accept="image/*"
              // style={{ display: 'none' }}
              ref={this.state.imageInputRef}
              onChange={this.handleImageInsert}
            />
          </div>

          {/* <button 
        className="ql-image button-icon" 
        onClick={() => this.state.imageInputRef.current.click()}
      /> */}

          <div className="ql-image button-icon toolbar-add-video">
            <input
              id="videoInput"
              type="file"
              accept="video/mp4,video/x-m4v,video/*"
              // style={{ display: 'none' }}
              ref={this.state.videoInputRef}
              onChange={this.handleVideoInsert}
            />
          </div>

          {/* <button
            className="ql-video button-icon"
            onClick={() => this.state.videoInputRef.current.click()}
          >
            video
          </button> */}

          <div className="ql-image button-icon toolbar-add-audio">
            <input
              id="audioInput"
              type="file"
              accept="audio/aac,audio/mp3,audio/vbr,audio/audible,audio/aiff,audio/wav,audio/alac,audio/*"
              // style={{ display: 'none' }}
              ref={this.state.audioInputRef}
              onChange={this.handleAudioInsert}
            />
          </div>

          {/* <button
            className="ql-music button-icon"
            onClick={() => this.state.audioInputRef.current.click()}
          >
            <AudioFileIcon />
          </button> */}

          {/* <button
          className="ql-word button-icon"
          onClick={() => this.state.wordInputRef.current.click()}
        >
          <DescriptionIcon />
        </button> */}

          <div className="ql-image button-icon toolbar-add-doc">
            <input
              id="wordInput"
              type="file"
              accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={this.handleWordInsert}
            />
          </div>

          {/* <div className="word-input-wrap">
            <span>
              <DescriptionSvg />
            </span>
            <input
              id="wordInput"
              type="file"
              accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={this.handleWordInsert}
            />
          </div> */}
        </div>
      </div>
    </>
  );

  handleImage() {
    // const imageInput = document.getElementById('imageInput');
    // imageInput.click();
    this.handleFile('image/*', 'image');
  }

  handleVideo() {
    this.handleFile('video/*', 'video');
  }

  handleMusic() {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'audio/*');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);

      const quill = this.state.contextObject.getEditor();
      const range = quill.getSelection(true);

      const storageRef = MyRef(myStorage, 'Домашние-задания/audio/' + file.name);

      try {
        await uploadBytesResumable(storageRef, file);

        const downloadURL = await getDownloadURL(storageRef);

        quill.insertEmbed(range.index, 'audio', downloadURL, Quill.sources.USER);

        this.setState({
          arrayFiles: this.state.arrayFiles.concat([downloadURL]),
        });
      } catch (error) {
        console.error(error);
        throwErrorRollbar(error);
      }
    };
  }

  handleNewPart() {
    let quill = this.state.contextObject.getEditor();
    let range = quill.getSelection(true);

    // Вставляем параграф перед <hr>
    quill.insertText(range.index, '\n', Quill.sources.USER);

    // Увеличиваем индекс, чтобы вставить <hr> после нового параграфа
    quill.insertEmbed(range.index + 1, 'divider', true, Quill.sources.USER);

    // Устанавливаем курсор после вставленного <hr>
    quill.setSelection(range.index + 2, Quill.sources.SILENT);
  }

  onSubjectChange = e => {
    let subject = e.target.selectedIndex == 0 ? null : e.target.value;
    this.setState({
      subject,
    });
  };

  handleFile(extension, type) {
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.setAttribute('accept', extension);
    input.click();

    input.onchange = async () => {
      let file = input.files[0];
      let formData = new FormData();
      formData.append('file', file);

      const storageRef = MyRef(myStorage, 'Домашние-задания/' + type + '/' + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });

            let quill = this.state.contextObject.getEditor();
            let range = quill.getSelection(true);

            // Добавляем видео как вложенный блок элемента
            quill.insertEmbed(range.index, 'video', downloadURL, Quill.sources.USER);

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });
          });
        },
      );
    };
  }

  handleChange = date => {
    this.setState({
      selectedDate: date,
    });
  };

  // 2. Функция для скроллинга:
  scrollToLine = index => {
    const { contextObject, lineIndices } = this.state;

    const lineIndex = lineIndices[index] === undefined ? lineIndices[lineIndices.length - 1] : lineIndices[index];
    console.log('Trying to scroll to line with data-line-index:', lineIndex);

    if (!contextObject || !contextObject.editor || !contextObject.editor.root) {
      console.error('Quill context or editor root is not available');
      const error = new Error('Quill context or editor root is not available');
      throwErrorRollbar(error);
      return;
    }

    const quillRoot = contextObject.editor.root;
    const element = quillRoot.querySelector(`[data-line-index="${lineIndex}"]`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      const container = quillRoot.parentElement;
      container.scrollTop -= 300;
    } else {
      console.error('Element with data-line-index not found:', lineIndex);
      const error = new Error('Element with data-line-index not found:');
      throwErrorRollbar(error);
    }
  };

  render() {
    return this.state.loading ? (
      <span className="spinner-border spinner-border-sm"></span>
    ) : (
      <div className="create-homework-wrap-block">
        {this.state.formPointsFlag && (
          <div className="form-points-block">
            <button
              className="btn btn-icon close-btn"
              onClick={e =>
                this.setState({
                  formPointsFlag: false,
                })
              }
            >
              <span className="icon icon-plus"></span>
            </button>

            <div className="form-points-block-items">
              {this.state.subArrayCheckeds.length > 1 &&
                this.state.subArrayCheckeds.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        this.state.titles[index] === undefined || this.state.titles[index].length === 0
                          ? 'input-colum error'
                          : 'input-colum'
                      }
                    >
                      <span onClick={() => this.scrollToLine(index)}>Пункт: {index + 1}</span>
                      <Input
                        type="text"
                        placeholder={this.props.t('item name')}
                        value={(this.state.titles && this.state.titles[index]) || ''}
                        onChange={e => this.handleInputChange(index, e)}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        )}

        <div className="editor-homework-page create-homework container">
          <div className="col-mg-12">
            <div className="input-colum">
              <span>{this.props.t('name') + ' '}</span>
              <Input onChange={this.onNameChange} value={this.state.name}></Input>
            </div>

            <br />
            {this.state.subjects.length > 0 ? (
              <div className="panel-navigation">
                <div className="wrap-select">
                  <FormControl>
                    <InputLabel id="subject-hw-label">{this.props.t('subject')}</InputLabel>

                    <Select
                      labelId="subject-label"
                      id="subject-hw-select"
                      value={this.state.subject}
                      label={this.props.t('subject')}
                      onChange={this.onSubjectChange}
                    >
                      {this.state.subjects
                        .sort((a, b) => this.props.t(a).localeCompare(this.props.t(b)))
                        .map((subject, i) => {
                          return (
                            <MenuItem key={i} value={this.props.t(subject)}>
                              {this.props.t(subject)}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
                <div className="wrap-picker">
                  <span className="title">{this.props.t('deadline')}</span>
                  <DatePicker
                    selected={this.state.selectedDate}
                    onChange={this.handleChange}
                    dateFormat="dd.MM.yyyy"
                    minDate={new Date()}
                  />
                </div>
              </div>
            ) : (
              <span>loading</span>
            )}
            <div className="check-notebook">
              {this.props.t('Do in your notebook') + ' '}
              <Input
                type="checkbox"
                checked={this.state.isForNotebook}
                onChange={e => {
                  this.setState({ isForNotebook: e.target.checked });
                }}
              />
            </div>
            <br />
            <div>
              <this.CustomToolbar></this.CustomToolbar>
              <ReactQuill
                modules={{
                  toolbar: {
                    container: '#toolbar',
                    handlers: {
                      music: this.handleClick,
                      image: this.handleClick,
                      video: this.handleClick,
                      insertLine: this.handleNewPart,
                    },
                  },
                  // imageResize: {
                  //   parchment: Quill.import('parchment'),
                  //   // modules: ['Resize'],
                  // },
                }}
                key={this.state.selectedDate}
                ref={this.setContext}
                value={this.state.content}
                onChange={this.onTextEditorChange}
                onKeyDown={this.onKeyDown}
                theme="snow"
              />
            </div>
            <br />
            <div className="btn-wrap">
              {!this.state.subArrayCheckeds ? (
                <Button
                  className={
                    this.state.name.length > 0 && this.state.subject.length > 0 ? 'btn-primary' : 'btn-primary disable'
                  }
                  disabled={this.state.loading}
                  onClick={this.save}
                >
                  {this.props.t('save')}
                </Button>
              ) : (
                <Button
                  className={
                    this.state.name.length > 0 &&
                    this.state.subject.length > 0 &&
                    !this.state.flagFormValidate &&
                    Object.values(this.state.titles).every(value => typeof value === 'string' && value.length > 0)
                      ? 'btn-primary'
                      : 'btn-primary disable'
                  }
                  disabled={this.state.loading}
                  onClick={this.save}
                >
                  {this.props.t('save')}
                </Button>
              )}
            </div>
            {this.state.message}
          </div>

          {
            <div className={this.state.progressFilePost > 0 ? 'progress-loader-wrap active' : 'progress-loader-wrap '}>
              <div className="progress-loader-item">
                <div className="progress-loader-content" style={{ width: this.state.progressFilePost + '%' }}>
                  <span>{this.state.progressFilePost}%</span>
                </div>
              </div>
            </div>
          }

          {this.state.imageSrc && <PopupImage src={this.state.imageSrc} onClose={this.closeImagePopup} />}

          {this.state.subArrayCheckeds.length > 1 && (
            <div className="wrap-button-form-points">
              <button
                className={
                  !this.state.flagFormValidate &&
                  Object.values(this.state.titles).every(value => typeof value === 'string' && value.length > 0)
                    ? 'button-form-points'
                    : 'button-form-points no-titels'
                }
                onClick={e =>
                  this.setState({
                    formPointsFlag: true,
                  })
                }
              >
                <FormatListNumberedIcon />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withNavigateHook(CreateHomework));
